/**
 * @internal
 * @param balanceData
 * @returns
 */
export function formatTokenBalance(balanceData, showSymbol = true) {
    return (Number(balanceData.displayValue).toFixed(3) +
        (showSymbol ? ` ${balanceData.symbol}` : ""));
}
//# sourceMappingURL=formatTokenBalance.js.map